import React, { PureComponent } from 'react';

class Article extends PureComponent {


  render() {
    const { title, description, img, link } = this.props;
    return (
      <div className="article">
        <a target="_blank" href={link}><img className="image pull-left" src={img}/></a>
        <div className="article__info">
          <h3>{title}</h3>
          <a target="_blank" href={link}>{description}</a>
        </div>
      </div>
    );
  }
}

Article.propTypes = {};
Article.defaultProps = {};

export default Article;



// WEBPACK FOOTER //
// ./src/components/article/Article.js